<script setup lang="ts" generic="T extends Category | Chapter | Folder">
import { CategorySchema } from "~/models/Content/schemas/content-search.schema"
import type { Category } from "~/models/Content/schemas/content-search.schema"
import type { Chapter, Folder } from "~/types/contentSearch"
import { safeParse } from "valibot"

const { data, toggle, parentLocationIdFilter } = defineProps<{
  data: T[],
  parentLocationIdFilter?: number | string,
  toggle: (id: T["id"]) => ReturnType<typeof navigateTo>
}>()

function isCategory(data: unknown): data is Category {
  return safeParse(CategorySchema, data).success
}

const filteredItems = computed(() => {
  if (!parentLocationIdFilter) return data

  return data.filter(item => !("parentLocationId" in item) || item.parentLocationId === parentLocationIdFilter)
})
</script>

<template>
    <section class="text-mobile-article-preview-p1 md:text-desktop-article-preview-p1 space-y-4">
      <u-feature-flag><span>Total: {{ filteredItems.reduce((sum, i) => sum + i.results, 0) }}</span></u-feature-flag>
      <div
        v-for="item in filteredItems" :key="item.id"
        :class="{ 'opacity-60': item.results === 0 && !isCategory(item) }"
      >
        <label
          class="flex items-center w-full mb-1 md:mb-2 group select-none cursor-pointer"
        >
          <USearchCheckbox
            :model-value="item.active"
            @update:model-value="toggle(item.id)"
          />
          <div
            class="flex items-center flex-1 min-w-0 gap-2 md:gap-4 ml-2 md:ml-3"
            :class="{
                  'text-[--theme-lighter]': item.results === 0 && !isCategory(item),
                }"
          >
            <div class="flex-1 min-w-0 truncate">
              <span v-if="'priority' in item">{{ item.priority }}.</span> {{ item.title }}
            </div>
            <div v-if="!isCategory(item)" class="flex-shrink-0 ml-1">
              ({{ item.results }})
              <span class="sr-only"> søketreff</span>
            </div>
          </div>
        </label>
        <slot v-if="item.active" :parent-location-id="item.id" />
      </div>
    </section>
</template>
